/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import React, {useCallback} from 'react';
import {Image, TouchableOpacity, View} from 'react-native';
import {connect} from 'react-redux';

import SubmitButtons from '../../../../components/Button/SecondaryButton';
import {InputDatePicker} from '../../../../components/Inputs/InputDatePicker';
import {InputField} from '../../../../components/Inputs/InputField';
// import CustomSwitch from '../../../../components/Inputs/CustomSwitch';
import {BoxShadowed} from '../../../../components/AssuranceVoyage';
import Button from '../../../../components/Button/PrimaryButton';
import ConfirmationModal from '../../../../components/Modal/ConfirmationModal/index.web';

import mapDispatchToProps from '../../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../../services/redux/mapStateToProps';

import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import {ValidationSouscription} from '../../../../../common/utils/validationAssuranceVoyage';
import {TitleLabels} from '../../../../../data/constants/Assurance/AssuranceVoyage/souscription';
import {IValues} from '../../../../../data/types/interface/Assurance/AssuranceVoyage/souscription';
import {ItemAgenceI} from '../../../../../data/types/interface/agence';
import {StackParams} from '../../../../../data/types/navigation';
import {useFormSouscription} from '../../../../../hooks/AssuranceVoyage/useFormSouscription';
import {InputImage} from '../../../../components/Inputs/InputImage/';
import {InputPhoneNumber} from '../../../../components/Inputs/InputPhoneNumber/index.web';
import Select from '../../../../components/Inputs/Select';
import {CustomSwitch} from '../../../../components/Switch';
import styles from '../styles';

interface FormProps {
  data: IValues;
  initData: IValues;
  setData: (value: IValues) => void;
  listAgence: Array<ItemAgenceI>;
  onCancelForm: () => void;
  onSubmitForm: (data: IValues) => void;
  user: any;
}
const FormFC = ({
  data,
  initData,
  setData,
  listAgence,
  onCancelForm,
  onSubmitForm,
  user,
}: FormProps) => {
  const {
    handleChange,
    handleSubmit,
    isDisable,
    handleCancel,
    values,
    errors,
    showErrors,
    handleAddAssured,
    handleRemoveAssured,
    handleChangeAssured,
    modalData,
  } = useFormSouscription(
    data,
    setData,
    initData,
    ValidationSouscription,
    onCancelForm,
    onSubmitForm,
    listAgence,
    user?.data?.utilisateur,
  );

  const ageLimit = localStorage.getItem('ageLimit');
  const ageMax = (ageLimit && parseInt(ageLimit, 10)) || 87;

  const currentUser = user?.data?.utilisateur;
  const {navigate} = useNavigation<StackNavigationProp<StackParams>>();

  useFocusEffect(
    useCallback(() => {
      if (!currentUser) {
        navigate('Login', {
          data: 'SouscriptionAssuranceVoyage',
          params: {
            ...values,
          },
        });
      }
    }, [currentUser]),
  );

  return (
    <View>
      <Select
        style={{flex: 0.45, marginBottom: 40}}
        data={
          listAgence.length
            ? [
                {label: 'Choisir Agence', value: ''},
                ...listAgence.map((element: ItemAgenceI) => ({
                  label: element.label,
                  value: element.value,
                })),
              ]
            : []
        }
        label="Agence"
        defaultValue={values.agence}
        required={true}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onChange={(name: string, data: any, fired: boolean) => {
          handleChange('agence', data, true);
        }}
        value={values.agence}
        error={errors.agence}
        showError={showErrors.agence}
      />
      <View>
        <CustomSwitch
          label="Assuré"
          name="userIsAssured"
          required
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          onChange={(name: string, value: boolean, fired?: boolean) =>
            handleChange(name as keyof IValues, value, true)
          }
          value={values.userIsAssured}
        />
      </View>

      {modalData.status ? (
        <ConfirmationModal
          title={modalData.title}
          content={modalData.content}
          btn1={modalData.btn1}
          btn2={modalData.btn2}
          handleBtn1={modalData.handleBtn1}
          handleBtn2={modalData.handleBtn2}
        />
      ) : null}
      {values.assure.length
        ? values.assure.map((assure, index: number) => {
            return (
              <BoxShadowed
                style={{paddingBottom: 40, marginBottom: 40}}
                key={`${assure.id}`}>
                {values.userIsAssured && index === 0 ? null : (
                  <TouchableOpacity
                    style={styles.closeBtn}
                    onPress={() => handleRemoveAssured(assure.id)}>
                    <Image
                      style={{width: 40, height: 40}}
                      // eslint-disable-next-line @typescript-eslint/no-require-imports
                      source={require('../../../../../ressources/images/close-1.png')}
                    />
                  </TouchableOpacity>
                )}
                <View>
                  <InputField
                    label={'Nom'}
                    required
                    value={assure.nom}
                    name="nom"
                    onChange={(name: string, value: any, fired: boolean) =>
                      handleChangeAssured(assure.id, name, value, fired)
                    }
                    error={
                      errors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.nom
                    }
                    showError={
                      showErrors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.nom
                    }
                    maxLength={70}
                    isEditable={!values.userIsAssured || index !== 0}
                  />
                  <InputField
                    label={'Prénom'}
                    required
                    value={assure.prenom}
                    name="prenom"
                    onChange={(name: string, value: any, fired: boolean) =>
                      handleChangeAssured(assure.id, name, value, fired)
                    }
                    error={
                      errors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.prenom
                    }
                    showError={
                      showErrors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.prenom
                    }
                    maxLength={70}
                    isEditable={!values.userIsAssured || index !== 0}
                  />
                  <InputDatePicker
                    label={TitleLabels.contractant.dateNaissanceBeneficiaire}
                    required
                    name="dateNaissance"
                    value={assure.dateNaissance}
                    onChange={(name: string, value: any, fired: boolean) =>
                      handleChangeAssured(assure.id, name, value, fired)
                    }
                    error={
                      errors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.dateNaissance
                    }
                    showError={
                      showErrors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.dateNaissance
                    }
                    isEditable={!values.userIsAssured || index !== 0}
                    dateMin={dayjs()
                      .subtract(ageMax, 'year')
                      .add(1, 'day')
                      .toDate()}
                    dateMax={dayjs().toDate()}
                    noInit
                  />
                  <InputField
                    label={'Lieu de naissance'}
                    required
                    value={assure.lieuNaissance}
                    name="lieuNaissance"
                    onChange={(name: string, value: any, fired: boolean) =>
                      handleChangeAssured(assure.id, name, value, fired)
                    }
                    error={
                      errors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.lieuNaissance
                    }
                    showError={
                      showErrors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.lieuNaissance
                    }
                    maxLength={70}
                  />
                  <InputField
                    label={'Email'}
                    required
                    value={assure.email}
                    name="email"
                    onChange={(name: string, value: any, fired: boolean) =>
                      handleChangeAssured(assure.id, name, value, fired)
                    }
                    error={
                      errors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.email
                    }
                    showError={
                      showErrors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.email
                    }
                    maxLength={70}
                    isEditable={!values.userIsAssured || index !== 0}
                    placeholder="Email de l'assuré ou d'un parent"
                  />
                  <InputPhoneNumber
                    label={'Numéro de Téléphone'}
                    required
                    name="telephone"
                    type="telephone"
                    value={assure.telephone}
                    onChange={(name: string, value: string, fired: any) =>
                      handleChangeAssured(assure.id, name, value, fired)
                    }
                    error={
                      errors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.telephone
                    }
                    showError={
                      showErrors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.telephone
                    }
                    country={assure?.countryCode || 'MG'}
                    onChangeCountry={(newCountry: string) =>
                      handleChangeAssured(
                        assure.id,
                        'countryCode',
                        newCountry,
                        true,
                      )
                    }
                  />
                  <InputDatePicker
                    label="Date d'expiration passeport"
                    required
                    value={assure.datePasseport}
                    name="datePasseport"
                    onChange={(name: string, value: any, fired: boolean) =>
                      handleChangeAssured(assure.id, name, value, fired)
                    }
                    error={
                      errors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.datePasseport
                    }
                    dateMin={new Date()}
                    dateMax={dayjs().add(100, 'year').toDate()}
                    noInit
                  />
                  <InputField
                    style={{flex: 1}}
                    label={'Numéro de passeport'}
                    type="numPasseport"
                    required
                    name="numPasseport"
                    value={assure.numPasseport}
                    onChange={(name: string, value: any, fired: boolean) =>
                      handleChangeAssured(assure.id, name, value, fired)
                    }
                    error={
                      errors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.numPasseport
                    }
                    showError={
                      showErrors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.numPasseport
                    }
                  />
                  <InputImage
                    style={{flex: 0.5, justifyContent: 'flex-end'}}
                    label={'Joindre le passeport'}
                    required
                    name="passport_file"
                    value={assure.passport_file ? assure.passport_file : []}
                    onChange={(
                      name: string,
                      value: any,
                      fired: boolean,
                      remove?: boolean,
                    ) => {
                      return handleChangeAssured(
                        assure.id,
                        name,
                        value,
                        fired,
                        remove,
                      );
                    }}
                    error={
                      errors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.passport_file
                    }
                    showError={
                      showErrors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.passport_file
                    }
                    maxLength={1}
                  />
                </View>
              </BoxShadowed>
            );
          })
        : null}
      <View style={styles.submitButtonsContainer}>
        <Button
          onPress={() => handleAddAssured()}
          styleBtnTxt={[styles.btnValider, {textAlign: 'center'}]}
          styleBtnOuter={[
            styles.btnValiderOuter,
            {maxWidth: 100, marginTop: 30},
          ]}
          styleContainer={styles.noFlexGrow}
          title={'Ajouter Assuré'}
          type="valider"
        />
        <SubmitButtons
          isDisable={!isDisable}
          cancelAction={handleCancel}
          submitAction={handleSubmit}
          cancelTitle="Annuler"
          submitTitle="Valider"
        />
      </View>
    </View>
  );
};
export const Form: any = connect(mapStateToProps, mapDispatchToProps)(FormFC);
